// [2026-10-07] ADDED — INC-279: pure list logic of the IncAssist live transcript
// [2026-10-15] ADDED — INC-279 IncAssist C1: the panel's list model
// [2026-10-16] CHANGED — INC-279 C5: + addCodeQuestions. Was:
// import {
//     addSkillQuestion,
//     clearIds,
//     COPILOT_UI_INIT,
//     markRead,
//     nextToast,
//     registerIds,
//     undoClear,
// } from '../../components/AICopilot/copilotListModel';
import {
    addCodeQuestions,
    addSkillQuestion,
    clearIds,
    COPILOT_UI_INIT,
    markRead,
    nextToast,
    registerIds,
    undoClear,
} from '../../components/AICopilot/copilotListModel';
// [2026-10-29] ADDED — INC-2050: the Proctoring tab's seen ids (see copilotProctoringModel.js addSeenIds)
import { addSeenIds } from '../../components/AICopilot/copilotProctoringModel';
// [2026-10-29] ADDED — INC-2049: merge of the Suggestions list saved in this browser
import { mergeSession } from '../../components/AICopilot/copilotSessionStore';
import { applyHistory, applySnapshot, latestCandidateSpan } from '../../components/AICopilot/transcriptModel';
import {
    ADD_COPILOT_BOOKMARK,
    ADD_COPILOT_BOOKMARK_FAILURE,
    ADD_COPILOT_BOOKMARK_SUCCESS,
    ADD_SCREENSHOT,
    ADD_SCREENSHOT_FAILURE,
    ADD_SCREENSHOT_SUCCESS,
    AI_ASSISTED_VALIDATE,
    AI_ASSISTED_VALIDATE_FAILURE,
    AI_ASSISTED_VALIDATE_SUCCESS,
    AI_CODING_COMMENT,
    AI_CODING_COMMENT_FAILURE,
    AI_CODING_COMMENT_SUCCESS,
    AI_SCREENING_COMMENT,
    AI_SCREENING_COMMENT_FAILURE,
    AI_SCREENING_COMMENT_SUCCESS,
    AUTO_APPROVE_FEEDBACK,
    AUTO_APPROVE_FEEDBACK_FAILURE,
    AUTO_APPROVE_FEEDBACK_SUCCESS,
    CANDIDATE_CALL_END,
    CANDIDATE_CALL_END_FAILURE,
    CANDIDATE_CALL_END_SUCCESS,
    CHECK_COPILOT_ANSWER_SUCCESS,
    CODE_EDITOR_LANGUAGE,
    CODE_EDITOR_LANGUAGE_FAILURE,
    CODE_EDITOR_LANGUAGE_SUCCESS,
    CONTACT_ADMIN,
    CONTACT_ADMIN_FAILURE,
    CONTACT_ADMIN_SUCCESS,
    COPILOT_AI_FLAGS_SEEN,
    // [2026-10-15] ADDED — INC-279 P3
    COPILOT_PROCTORING_FOCUS,
    COPILOT_PROCTORING_SEEN,
    // [2026-10-29] ADDED — INC-2049
    COPILOT_SESSION_RESTORE,
    COPILOT_TRANSCRIPT_SNAPSHOT,
    COPILOT_UI_CLEAR,
    COPILOT_UI_PATCH,
    COPILOT_UI_READ,
    COPILOT_UI_REGISTER,
    COPILOT_UI_UNDO,
    CREATE_AND_UPDATE_SCREENSHOT,
    CREATE_AND_UPDATE_SCREENSHOT_FAILURE,
    CREATE_AND_UPDATE_SCREENSHOT_SUCCESS,
    CREATE_CODE_SUBMISSION,
    CREATE_CODE_SUBMISSION_FAILURE,
    CREATE_CODE_SUBMISSION_SUCCESS,
    DELETE_COPILOT_BOOKMARK,
    DELETE_COPILOT_BOOKMARK_FAILURE,
    DELETE_COPILOT_BOOKMARK_SUCCESS,
    DELETE_RECORDING,
    DELETE_RECORDING_FAILURE,
    DELETE_RECORDING_SUCCESS,
    FACE_EXPRESSION,
    FACE_EXPRESSION_FAILURE,
    FACE_EXPRESSION_SUCCESS,
    FETCH_SCREENSHOT_IMAGE,
    FETCH_SCREENSHOT_IMAGE_FAILURE,
    FETCH_SCREENSHOT_IMAGE_TYPE1_SUCCESS,
    FETCH_SCREENSHOT_IMAGE_TYPE2_SUCCESS,
    FETCH_SCREENSHOT_IMAGE_TYPE3_SUCCESS,
    FETCH_SCREENSHOT_IMAGE_TYPE4_SUCCESS,
    FETCH_SCREENSHOT_IMAGE_TYPE5_SUCCESS,
    FETCH_SCREENSHOT_IMAGEV2,
    FETCH_SCREENSHOT_IMAGEV2_FAILURE,
    FETCH_SCREENSHOT_IMAGEV2_SUCCESS,
    FETCH_SCREENSHOT_IMAGEV3,
    FETCH_SCREENSHOT_IMAGEV3_FAILURE,
    FETCH_SCREENSHOT_IMAGEV3_SUCCESS,
    FETCH_TRANSCRIPT,
    FETCH_TRANSCRIPT_FAILURE,
    FETCH_TRANSCRIPT_SUCCESS,
    FULL_FACE_DETECTION_NEW,
    FULL_FACE_DETECTION_NEW_FAILURE,
    FULL_FACE_DETECTION_NEW_SUCCESS,
    GENERATE_AI_COMMENT,
    GENERATE_AI_COMMENT_FAILURE,
    GENERATE_AI_COMMENT_SUCCESS,
    GENERATE_CANDIDATE_FEEDBACK,
    GENERATE_CANDIDATE_FEEDBACK_FAILURE,
    GENERATE_CANDIDATE_FEEDBACK_SUCCESS,
    GENERATE_RESUME_SUMMARY,
    GENERATE_RESUME_SUMMARY_FAILURE,
    GENERATE_RESUME_SUMMARY_SUCCESS,
    GET_AI_COPILOT_QUESTIONS,
    GET_AI_COPILOT_QUESTIONS_FAILURE,
    GET_AI_COPILOT_QUESTIONS_SUCCESS,
    GET_ALL_SCREENSHOT,
    GET_ALL_SCREENSHOT_FAILURE,
    GET_ALL_SCREENSHOT_SUCCESS,
    GET_CANDIDATE_INTERVIEW_DETAILS,
    GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE,
    GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS,
    GET_CODE_SUBMISSION,
    GET_CODE_SUBMISSION_FAILURE,
    GET_CODE_SUBMISSION_SUCCESS,
    GET_COPILOT_BOOKMARKS,
    GET_COPILOT_BOOKMARKS_FAILURE,
    GET_COPILOT_BOOKMARKS_SUCCESS,
    // [2026-10-16] ADDED — INC-279 IncAssist C5
    GET_COPILOT_CODE_FOLLOW_UPS_SUCCESS,
    // [2026-10-15] ADDED — INC-279 F
    GET_COPILOT_SKILL_QUESTION_FAILURE,
    GET_COPILOT_SKILL_QUESTION_SUCCESS,
    GET_COPILOT_STARTERS_SUCCESS,
    GET_COPILOT_STATE_SUCCESS,
    GET_COPILOT_TRANSCRIPT_SUCCESS,
    GET_CROP_IMAGE,
    GET_CROP_IMAGE_FAILURE,
    GET_CROP_IMAGE_SUCCESS,
    GET_FEEDBACK,
    GET_FEEDBACK_FAILURE,
    GET_FEEDBACK_SUCCESS,
    GET_FINAL_TRANSCRIPT,
    GET_FINAL_TRANSCRIPT_FAILURE,
    GET_FINAL_TRANSCRIPT_SUCCESS,
    GET_INTERVIEW_DETAILS,
    GET_INTERVIEW_DETAILS_FAILURE,
    GET_INTERVIEW_DETAILS_SUCCESS,
    GET_INTERVIEW_TOKEN,
    GET_INTERVIEW_TOKEN_FAILURE,
    GET_INTERVIEW_TOKEN_SUCCESS,
    GET_INTERVIEWER_INTERVIEW_DETAILS,
    GET_INTERVIEWER_INTERVIEW_DETAILS_FAILURE,
    GET_INTERVIEWER_INTERVIEW_DETAILS_SUCCESS,
    GET_RECORDING_LIST,
    GET_RECORDING_LIST_FAILURE,
    GET_RECORDING_LIST_SUCCESS,
    GET_REGENERATED_AI_SUMMARY,
    GET_REGENERATED_AI_SUMMARY_FAILURE,
    GET_REGENERATED_AI_SUMMARY_SUCCESS,
    GET_SCREENSHOT,
    GET_SCREENSHOT_FAILURE,
    GET_SCREENSHOT_SUCCESS,
    GET_SKILLS,
    GET_SKILLS_FAILURE,
    GET_SKILLS_SUCCESS,
    GET_URL_GENERATED_ID,
    GET_URL_GENERATED_ID_FAILURE,
    GET_URL_GENERATED_ID_SUCCESS,
    INTERVIEWER_CALL_END,
    INTERVIEWER_CALL_END_FAILURE,
    INTERVIEWER_CALL_END_SUCCESS,
    LOOKING_FORWARD,
    LOOKING_FORWARD_FAILURE,
    LOOKING_FORWARD_SUCCESS,
    MOVEMENT,
    MOVEMENT_FAILURE,
    MOVEMENT_SUCCESS,
    NOTIFY_INTERVIEWER,
    NOTIFY_INTERVIEWER_FAILURE,
    NOTIFY_INTERVIEWER_SUCCESS,
    PASS_CHECK_MANUALLY,
    PASS_CHECK_MANUALLY_FAILURE,
    PASS_CHECK_MANUALLY_SUCCESS,
    POST_ANALYTICS,
    POST_ANALYTICS_FAILURE,
    POST_ANALYTICS_SUCCESS,
    POST_CAR_FEEDBACK_DETAILS,
    POST_CAR_FEEDBACK_DETAILS_FAILURE,
    POST_CAR_FEEDBACK_DETAILS_SUCCESS,
    POST_CONSENT,
    POST_CONSENT_FAILURE,
    POST_CONSENT_SUCCESS,
    POST_FEEDBACK_DETAILS,
    POST_FEEDBACK_DETAILS_FAILURE,
    POST_FEEDBACK_DETAILS_SUCCESS,
    POST_INTERVIEW_FEEDBACK,
    POST_INTERVIEW_FEEDBACK_FAILURE,
    POST_INTERVIEW_FEEDBACK_SUCCESS,
    POST_NOSHOW_FEEDBACK_DETAILS,
    POST_NOSHOW_FEEDBACK_DETAILS_FAILURE,
    POST_NOSHOW_FEEDBACK_DETAILS_SUCCESS,
    QUESTION_BANK,
    QUESTION_BANK_FAILURE,
    QUESTION_BANK_LIST,
    QUESTION_BANK_LIST_FAILURE,
    QUESTION_BANK_LIST_SUCCESS,
    QUESTION_BANK_SUCCESS,
    REMOVE_SCREENSHOT_IMAGE,
    ROOM_UPDATE,
    ROOM_UPDATE_FAILURE,
    ROOM_UPDATE_SUCCESS,
    SAVE_RESUME_SUMMARY,
    SAVE_RESUME_SUMMARY_FAILURE,
    SAVE_RESUME_SUMMARY_SUCCESS,
    SET_SHOW_FEEDBACK_PORTAL,
    SINGLE_CODE_EDITOR_LANGUAGE,
    SINGLE_CODE_EDITOR_LANGUAGE_FAILURE,
    SINGLE_CODE_EDITOR_LANGUAGE_SUCCESS,
    START_MEETING,
    START_MEETING_FAILURE,
    START_MEETING_SUCCESS,
    SWITCH_TAB,
    SWITCH_TAB_FAILURE,
    SWITCH_TAB_SUCCESS,
    UPDATE_JOIN_NAME,
    UPDATE_JOIN_NAME_FAILURE,
    UPDATE_JOIN_NAME_SUCCESS,
    UPLOAD_AUDIO_AND_ANALYSE,
    UPLOAD_AUDIO_AND_ANALYSE_FAILURE,
    UPLOAD_AUDIO_AND_ANALYSE_SUCCESS,
    UPLOAD_CANDIDATE_VIDEO,
    UPLOAD_CANDIDATE_VIDEO_FAILURE,
    UPLOAD_CANDIDATE_VIDEO_SUCCESS,
    VERIFY_INTERVIEW_KEY,
    VERIFY_INTERVIEW_KEY_FAILURE,
    VERIFY_INTERVIEW_KEY_SUCCESS,
    VIDEO_UPLOAD,
    VIDEO_UPLOAD_FAILURE,
    VIDEO_UPLOAD_SUCCESS,
} from '../action/types';

const INIT_STATE = {
    loading: false,
    submitLoading: false,
    skills: null,
    interviewDetails: null,
    codeEditorLanguageList: null,
    codeEditorLangDetails: null,
    codeSubmissionOutput: null,
    interviewTokenDetails: null,
    showFeedback: true,
    questionBank: null,
    languageList: null,
    verifyKey: null,
    fetchImage1: null,
    fetchImage2: null,
    fetchImage3: null,
    fetchImage4: null,
    fetchImage5: null,
    fetchImagev2: null,
    fetchImagev3: null,
    feedbackDetails: null,
    recordingLists: null,
    screenshotLists: null,
    allScreenshots: null,
    cropImage: null,
    meetingInfo: null,
    screenshotsList: null,
    urlGeneratedId: null,
    urlGeneratedIdLoader: null,
    regeneratedAiSummary: null,
    regeneratedAiSummaryLoader: false,
    finalTranscript: null,
    finalTranscriptLoading: false,
    fetchLoading: false,
    fetchLoadingFail: false,
    isUploadingVideo: 'NO',
    analysisLoading: false,
    analysisResult: null,
    screenshotImage: null,
    quesLoading: false,
    postFeedbackLoading: false,
    aiCopilotQuestions: [],
    aiCopilotQuestionsLoading: false,
    candidateAiAnalysis: [],
    aiCopilotSkillCoverage: [],
    copilotBookmarks: [],
    copilotBookmarksLoading: false,
    addCopilotBookmarkLoading: false,
    deleteCopilotBookmarkLoading: false,
    // [2026-10-07] ADDED — INC-279: IncAssist "Live transcript" tab and the AI-assisted mark
    copilotTranscript: [], // lines — see components/AICopilot/transcriptModel.js
    copilotTranscriptPushes: 0, // push events received (0 = older backend, the room refreshes more often)
    copilotTranscriptGap: 0, // bumped when a push no longer adds up; the room then reloads the history
    copilotAiFlags: [], // [{ key, source, from, to, score, seen }] — answers the detector flagged
    aiCopilotLastSeq: 0, // number of the newest follow-up request whose reply was applied
    // [2026-10-15] ADDED — INC-279 F (D1/D2): from POST /getCopilotState. Nothing shows them yet (the panel is
    // rebuilt in C1); they are filled so C1 can read them.
    copilotSkillCounts: [], // [{ name, skill_type, count }] — questions asked per job skill
    copilotQuestionsCounted: 0,
    // [2026-10-15] ADDED — INC-279 F: the copilotProctoring* namespace, a seam for the Proctoring track (P3 fills it
    // from getCopilotState.proctoring). Unused in F.
    copilotProctoringEntries: [],
    copilotProctoringCounts: { tab: 0, ai: 0, new_since: 0 },
    copilotProctoringLatestAt: null,
    // [2026-10-15] ADDED — INC-279 IncAssist P3: getCopilotState.interview_started_at (the log's mm:ss), when the
    // interviewer last looked at the Proctoring tab (sent as proctoring_since → counts.new_since), the entry to focus.
    copilotProctoringStartedAt: null,
    copilotProctoringSeenAt: null,
    // [2026-10-29] ADDED — INC-2050: ids of the flagged events the interviewer has seen on the Proctoring tab (id → true);
    // null until the tab is first seen. The badge's "N new" = flagged entries not in it (no clock comparison).
    copilotProctoringSeenIds: null,
    copilotProctoringFocus: null, // { id, key }
    // [2026-10-15] ADDED — INC-279 IncAssist C1/C2: the mock panel's UI state (cleared/undo/unread/order/toast/flash), the
    // starters plan (getCopilotStarters + getCopilotState.plan) and the "+ Get a question" cards.
    copilotUi: COPILOT_UI_INIT,
    copilotPlan: { status: 'none' },
    copilotSkillQuestions: [],
    // [2026-10-16] ADDED — INC-279 IncAssist C5: the "Coding" cards (code follow-ups), newest first. Browser only.
    copilotCodeQuestions: [],
    // [2026-10-17] ADDED — INC-279 IncAssist RS: getCopilotState.repo_scan (the "Project: <repo>" cards). 'unknown' until
    // the first state reply, so a reload that finds the scan already ready shows no "Project questions ready" toast.
    copilotRepoScan: { status: 'unknown' },
};

// [2026-10-05] ADDED — INC-279: IncAssist list limits. QA saw 20-30 questions at once; the PRD shows a short,
// fresh list. Each reply adds at most 4, newest on top, and the panel keeps at most 12.
// [2026-10-06] CHANGED — INC-279: exactly 2 follow-ups per answer now (Rujal, 2026-10-06).
// const AI_COPILOT_MAX_PER_BATCH = 4;
const AI_COPILOT_MAX_PER_BATCH = 2;
// [2026-10-15] CHANGED — INC-279 C1: the list has no cap any more (CONTRACTS Round 1). Was:
// const AI_COPILOT_MAX_VISIBLE = 12;
// [2026-10-07] ADDED — INC-279: AI-assisted flags kept for one interview (far above any real number).
const COPILOT_AI_FLAGS_MAX = 50;
// Text with no Latin letters/digits falls back to its trimmed lower-case form (never an empty key).
const normalizeCopilotQuestion = (text) =>
    (text || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim() || (text || '').trim().toLowerCase();

const Interview = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FACE_EXPRESSION:
            return { ...state, loading: false };
        case FACE_EXPRESSION_SUCCESS:
            return { ...state, loading: false };
        case FACE_EXPRESSION_FAILURE:
            return { ...state, loading: false };

        case UPLOAD_CANDIDATE_VIDEO:
            return { ...state, loading: false };
        case UPLOAD_CANDIDATE_VIDEO_SUCCESS:
            return { ...state, loading: false };
        case UPLOAD_CANDIDATE_VIDEO_FAILURE:
            return { ...state, loading: false };

        case AI_ASSISTED_VALIDATE:
            return { ...state, loading: false };
        case AI_ASSISTED_VALIDATE_SUCCESS:
            return { ...state, loading: false };
        case AI_ASSISTED_VALIDATE_FAILURE:
            return { ...state, loading: false };

        case UPDATE_JOIN_NAME:
            return { ...state, loading: false };
        case UPDATE_JOIN_NAME_SUCCESS:
            return { ...state, loading: false };
        case UPDATE_JOIN_NAME_FAILURE:
            return { ...state, loading: false };

        case POST_ANALYTICS:
            return { ...state, loading: false };
        case POST_ANALYTICS_SUCCESS:
            return { ...state, loading: false };
        case POST_ANALYTICS_FAILURE:
            return { ...state, loading: false };

        case POST_CAR_FEEDBACK_DETAILS:
            return { ...state, loading: true };
        case POST_CAR_FEEDBACK_DETAILS_SUCCESS:
            return { ...state, loading: false };
        case POST_CAR_FEEDBACK_DETAILS_FAILURE:
            return { ...state, loading: false };

        case ROOM_UPDATE:
            return { ...state, loading: false };
        case ROOM_UPDATE_SUCCESS:
            return { ...state, loading: false };
        case ROOM_UPDATE_FAILURE:
            return { ...state, loading: false };

        case POST_NOSHOW_FEEDBACK_DETAILS:
            return { ...state, loading: true };
        case POST_NOSHOW_FEEDBACK_DETAILS_SUCCESS:
            return { ...state, loading: false };
        case POST_NOSHOW_FEEDBACK_DETAILS_FAILURE:
            return { ...state, loading: false };

        case NOTIFY_INTERVIEWER:
            return { ...state, loading: true };
        case NOTIFY_INTERVIEWER_SUCCESS:
            return { ...state, loading: false };
        case NOTIFY_INTERVIEWER_FAILURE:
            return { ...state, loading: false };

        case SWITCH_TAB:
            return { ...state, loading: false };
        case SWITCH_TAB_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case SWITCH_TAB_FAILURE:
            return { ...state, loading: false };

        case MOVEMENT:
            return { ...state, loading: true };
        case MOVEMENT_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case MOVEMENT_FAILURE:
            return { ...state, loading: false };

        case GET_CROP_IMAGE:
            return { ...state, loading: true };
        case GET_CROP_IMAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                cropImage: action.payload,
            };
        case GET_CROP_IMAGE_FAILURE:
            return { ...state, loading: false };

        case GET_SCREENSHOT:
            return { ...state, loading: true };
        case GET_SCREENSHOT_SUCCESS:
            return {
                ...state,
                loading: false,
                screenshotLists: action.payload,
            };
        case GET_SCREENSHOT_FAILURE:
            return { ...state, loading: false };

        case GET_ALL_SCREENSHOT:
            return { ...state, loading: true };
        case GET_ALL_SCREENSHOT_SUCCESS:
            return {
                ...state,
                loading: false,
                allScreenshots: action.payload,
            };
        case GET_ALL_SCREENSHOT_FAILURE:
            return { ...state, loading: false };

        case CREATE_AND_UPDATE_SCREENSHOT:
            return { ...state, loading: true };
        case CREATE_AND_UPDATE_SCREENSHOT_SUCCESS:
            return {
                ...state,
                loading: false,
                screenshotLists: action.payload,
            };
        case CREATE_AND_UPDATE_SCREENSHOT_FAILURE:
            return { ...state, loading: false };

        case ADD_SCREENSHOT:
            return { ...state, loading: true };
        case ADD_SCREENSHOT_SUCCESS:
            return {
                ...state,
                loading: false,
                screenshotsList: action.payload,
            };
        case ADD_SCREENSHOT_FAILURE:
            return { ...state, loading: false };

        case GET_RECORDING_LIST:
            return { ...state, loading: true };
        case GET_RECORDING_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                recordingLists: action.payload,
            };
        case GET_RECORDING_LIST_FAILURE:
            return { ...state, loading: false };

        case DELETE_RECORDING:
            return { ...state, loading: true };
        case DELETE_RECORDING_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case DELETE_RECORDING_FAILURE:
            return { ...state, loading: false };

        case CANDIDATE_CALL_END:
            return { ...state, loading: true };
        case CANDIDATE_CALL_END_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case CANDIDATE_CALL_END_FAILURE:
            return { ...state, loading: false };

        case INTERVIEWER_CALL_END:
            return { ...state, loading: true };
        case INTERVIEWER_CALL_END_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case INTERVIEWER_CALL_END_FAILURE:
            return { ...state, loading: false };

        case VERIFY_INTERVIEW_KEY:
            return { ...state, loading: true };
        case VERIFY_INTERVIEW_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                verifyKey: action.payload,
            };
        case VERIFY_INTERVIEW_KEY_FAILURE:
            return { ...state, loading: false };

        case REMOVE_SCREENSHOT_IMAGE:
            return {
                ...state,
                loading: false,
                fetchImage3: null,
            };

        case FETCH_SCREENSHOT_IMAGE:
            return {
                ...state,
                loading: false,
                fetchImage1: null,
                fetchImage2: null,
                fetchImage3: null,
                fetchImage4: null,
                fetchImage5: null,
            };
        case FETCH_SCREENSHOT_IMAGE_TYPE1_SUCCESS:
            return {
                ...state,
                loading: false,
                fetchImage1: action.payload,
            };
        case FETCH_SCREENSHOT_IMAGE_TYPE2_SUCCESS:
            return {
                ...state,
                loading: false,
                fetchImage2: action.payload,
            };
        case FETCH_SCREENSHOT_IMAGE_TYPE3_SUCCESS:
            return {
                ...state,
                loading: false,
                fetchImage3: action.payload,
            };
        case FETCH_SCREENSHOT_IMAGE_TYPE4_SUCCESS:
            return {
                ...state,
                loading: false,
                fetchImage4: action.payload,
            };
        case FETCH_SCREENSHOT_IMAGE_TYPE5_SUCCESS:
            return {
                ...state,
                loading: false,
                fetchImage5: action.payload,
            };
        case FETCH_SCREENSHOT_IMAGE_FAILURE:
            return { ...state, loading: false };

        case FETCH_SCREENSHOT_IMAGEV2:
            return { ...state, loading: false };
        case FETCH_SCREENSHOT_IMAGEV2_SUCCESS:
            return {
                ...state,
                loading: false,
                fetchImagev2: action.payload,
            };
        case FETCH_SCREENSHOT_IMAGEV2_FAILURE:
            return { ...state, loading: false };

        case FETCH_SCREENSHOT_IMAGEV3:
            return { ...state, loading: false };
        case FETCH_SCREENSHOT_IMAGEV3_SUCCESS:
            return {
                ...state,
                loading: false,
                fetchImagev3: action.payload,
            };
        case FETCH_SCREENSHOT_IMAGEV3_FAILURE:
            return { ...state, loading: false };

        case QUESTION_BANK:
            return { ...state, quesLoading: true };
        case QUESTION_BANK_SUCCESS:
            return {
                ...state,
                quesLoading: false,
                questionBank: action.payload,
            };
        case QUESTION_BANK_FAILURE:
            return { ...state, quesLoading: false };

        case QUESTION_BANK_LIST:
            return { ...state, loading: true };
        case QUESTION_BANK_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                languageList: action.payload,
            };
        case QUESTION_BANK_LIST_FAILURE:
            return { ...state, loading: false };

        case GET_INTERVIEW_TOKEN:
            return { ...state, loading: true };
        case GET_INTERVIEW_TOKEN_SUCCESS:
            return {
                ...state,
                loading: false,
                interviewTokenDetails: action.payload,
            };
        case GET_INTERVIEW_TOKEN_FAILURE:
            return { ...state, loading: false };

        case GET_SKILLS:
            return { ...state, loading: true };
        case GET_SKILLS_SUCCESS:
            return { ...state, loading: false, skills: action.payload };
        case GET_SKILLS_FAILURE:
            return { ...state, loading: false };

        case GET_FEEDBACK:
            return { ...state, loading: true };
        case GET_FEEDBACK_SUCCESS:
            return { ...state, loading: false, feedbackDetails: action.payload };
        case GET_FEEDBACK_FAILURE:
            return { ...state, loading: false };

        case GET_CODE_SUBMISSION:
            return { ...state, loading: true };
        case GET_CODE_SUBMISSION_SUCCESS:
            return { ...state, loading: false, codeToSubmit: action.payload };
        case GET_CODE_SUBMISSION_FAILURE:
            return { ...state, loading: false };

        case CREATE_CODE_SUBMISSION:
            return { ...state, submitLoading: true };
        case CREATE_CODE_SUBMISSION_FAILURE:
            return { ...state, submitLoading: false };
        case CREATE_CODE_SUBMISSION_SUCCESS:
            return {
                ...state,
                submitLoading: false,
                codeSubmissionOutput: action.payload,
            };

        case SINGLE_CODE_EDITOR_LANGUAGE:
            return { ...state, loading: true };
        case SINGLE_CODE_EDITOR_LANGUAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                codeEditorLangDetails: action.payload,
            };
        case SINGLE_CODE_EDITOR_LANGUAGE_FAILURE:
            return { ...state, loading: false };

        case CODE_EDITOR_LANGUAGE:
            return { ...state, loading: true };
        case CODE_EDITOR_LANGUAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                codeEditorLanguageList: action.payload,
            };
        case CODE_EDITOR_LANGUAGE_FAILURE:
            return { ...state, loading: false };

        case POST_INTERVIEW_FEEDBACK:
            return { ...state, loading: true };
        case POST_INTERVIEW_FEEDBACK_SUCCESS:
            return { ...state, loading: false };
        case POST_INTERVIEW_FEEDBACK_FAILURE:
            return { ...state, loading: false };

        case CONTACT_ADMIN:
            return { ...state, loading: true };
        case CONTACT_ADMIN_SUCCESS:
            return { ...state, loading: false };
        case CONTACT_ADMIN_FAILURE:
            return { ...state, loading: false };

        case POST_FEEDBACK_DETAILS:
            return { ...state, loading: false, postFeedbackLoading: true };
        case POST_FEEDBACK_DETAILS_SUCCESS:
            return { ...state, loading: false, postFeedbackLoading: false };
        case POST_FEEDBACK_DETAILS_FAILURE:
            return { ...state, loading: false, postFeedbackLoading: false };

        case GET_INTERVIEW_DETAILS:
            return { ...state, loading: true };
        case GET_INTERVIEW_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                interviewDetails: action.payload,
            };
        case GET_INTERVIEW_DETAILS_FAILURE:
            return { ...state, loading: false };

        case GET_CANDIDATE_INTERVIEW_DETAILS:
            return { ...state, loading: true };
        case GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                interviewDetails: action.payload,
            };
        case GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE:
            return { ...state, loading: false };

        case GET_INTERVIEWER_INTERVIEW_DETAILS:
            return { ...state, loading: true };
        case GET_INTERVIEWER_INTERVIEW_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                interviewDetails: action.payload,
            };
        case GET_INTERVIEWER_INTERVIEW_DETAILS_FAILURE:
            return { ...state, loading: false };

        case SET_SHOW_FEEDBACK_PORTAL:
            return { ...state, showFeedback: action.payload };

        case START_MEETING:
            return {
                ...state,
            };
        case START_MEETING_SUCCESS:
            return {
                ...state,
                meetingInfo: action.payload,
            };
        case START_MEETING_FAILURE:
            return {
                ...state,
            };
        case GET_URL_GENERATED_ID:
            return { ...state, urlGeneratedIdLoader: true };
        case GET_URL_GENERATED_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                urlGeneratedId: action.payload,
                urlGeneratedIdLoader: false,
            };
        case GET_URL_GENERATED_ID_FAILURE:
            return { ...state, urlGeneratedIdLoader: false };
        case GET_REGENERATED_AI_SUMMARY:
            return { ...state, regeneratedAiSummaryLoader: true };
        case GET_REGENERATED_AI_SUMMARY_SUCCESS:
            return { ...state, regeneratedAiSummaryLoader: false, regeneratedAiSummary: action.payload };
        case GET_REGENERATED_AI_SUMMARY_FAILURE:
            return { ...state, regeneratedAiSummaryLoader: false };
        case GET_FINAL_TRANSCRIPT:
            return { ...state, finalTranscriptLoading: true };
        case GET_FINAL_TRANSCRIPT_SUCCESS:
            return { ...state, finalTranscriptLoading: false, finalTranscript: action.payload };
        case GET_FINAL_TRANSCRIPT_FAILURE:
            return { ...state, finalTranscriptLoading: false };
        case FETCH_TRANSCRIPT:
            return { ...state, fetchLoading: true, fetchLoadingFail: false };
        case FETCH_TRANSCRIPT_SUCCESS:
            return {
                ...state,
                fetchLoading: false,
                fetchLoadingFail: false,
            };
        case FETCH_TRANSCRIPT_FAILURE:
            return {
                ...state,
                fetchLoading: false,
                fetchLoadingFail: true,
            };
        case VIDEO_UPLOAD:
            return {
                ...state,
                isUploadingVideo: 'YES',
            };
        case VIDEO_UPLOAD_SUCCESS:
            return {
                ...state,
                isUploadingVideo: 'SUCCESS',
            };
        case VIDEO_UPLOAD_FAILURE:
            return {
                ...state,
                isUploadingVideo: 'FAILURE',
            };

        case POST_CONSENT:
            return { ...state, loading: true };
        case POST_CONSENT_SUCCESS:
            return { ...state, loading: false };
        case POST_CONSENT_FAILURE:
            return { ...state, loading: false };

        case LOOKING_FORWARD:
        case LOOKING_FORWARD_SUCCESS:
        case LOOKING_FORWARD_FAILURE:
            return { ...state };

        case GENERATE_AI_COMMENT:
            return { ...state, loading: true };
        case GENERATE_AI_COMMENT_FAILURE:
            return { ...state, loading: false };
        case GENERATE_AI_COMMENT_SUCCESS:
            return { ...state, loading: false };
        case UPLOAD_AUDIO_AND_ANALYSE:
            return { ...state, analysisLoading: true };
        case UPLOAD_AUDIO_AND_ANALYSE_SUCCESS:
            return { ...state, analysisLoading: false, analysisResult: action.payload };
        case UPLOAD_AUDIO_AND_ANALYSE_FAILURE:
            return { ...state, analysisLoading: false };
        case FULL_FACE_DETECTION_NEW:
            return { ...state, loading: true };
        case FULL_FACE_DETECTION_NEW_SUCCESS:
            return { ...state, loading: false, screenshotImage: action.payload };
        case FULL_FACE_DETECTION_NEW_FAILURE:
            return { ...state, loading: false };
        case AI_CODING_COMMENT:
            return { ...state, loading: true };
        case AI_CODING_COMMENT_SUCCESS:
            return { ...state, loading: false };
        case AI_CODING_COMMENT_FAILURE:
            return { ...state, loading: false };
        case AI_SCREENING_COMMENT:
            return { ...state, loading: true };
        case AI_SCREENING_COMMENT_SUCCESS:
            return { ...state, loading: false };
        case AI_SCREENING_COMMENT_FAILURE:
            return { ...state, loading: false };
        case GENERATE_CANDIDATE_FEEDBACK:
            return { ...state, loading: true };
        case GENERATE_CANDIDATE_FEEDBACK_SUCCESS:
            return { ...state, loading: false };
        case GENERATE_CANDIDATE_FEEDBACK_FAILURE:
            return { ...state, loading: false };
        case PASS_CHECK_MANUALLY:
            return { ...state, loading: true };
        case PASS_CHECK_MANUALLY_SUCCESS:
            return { ...state, loading: false };
        case PASS_CHECK_MANUALLY_FAILURE:
            return { ...state, loading: false };
        case AUTO_APPROVE_FEEDBACK:
            return { ...state, loading: true };
        case AUTO_APPROVE_FEEDBACK_SUCCESS:
            return { ...state, loading: false };
        case AUTO_APPROVE_FEEDBACK_FAILURE:
            return { ...state, loading: false };
        case GENERATE_RESUME_SUMMARY:
            return { ...state, loading: true, postFeedbackLoading: true };
        case GENERATE_RESUME_SUMMARY_SUCCESS:
            return { ...state, loading: false, postFeedbackLoading: false };
        case GENERATE_RESUME_SUMMARY_FAILURE:
            return { ...state, loading: false, postFeedbackLoading: false };
        case SAVE_RESUME_SUMMARY:
            return { ...state, loading: true };
        case SAVE_RESUME_SUMMARY_SUCCESS:
            return { ...state, loading: false };
        case SAVE_RESUME_SUMMARY_FAILURE:
            return { ...state, loading: false };
        case GET_AI_COPILOT_QUESTIONS:
            return { ...state, aiCopilotQuestionsLoading: true };
        // [2026-10-05] CHANGED — INC-279: the list used to grow forever (every reply appended, duplicates kept).
        // case GET_AI_COPILOT_QUESTIONS_SUCCESS:
        //     return {
        //         ...state,
        //         aiCopilotQuestionsLoading: false,
        //         aiCopilotQuestions: [...state.aiCopilotQuestions, ...(action.payload.next_questions || [])],
        //         aiCopilotSkillCoverage: action.payload.skill_coverage || state.aiCopilotSkillCoverage,
        //         candidateAiAnalysis: action.payload.candidate_ai_analysis || state.candidateAiAnalysis,
        //     };
        // [2026-10-07] CHANGED — INC-279: two additions, both only active when the reply carries the new fields
        // (an older backend's reply behaves exactly as before):
        //   1. request_seq — requests run side by side (takeEvery), so an older reply can arrive after a newer
        //      one that already put questions on screen. It is ignored instead of putting stale ones on top.
        //   2. answer.key — the backend names the answer a reply belongs to. When the candidate pauses and then
        //      carries on with the same answer, the new questions REPLACE that answer's earlier ones instead of
        //      stacking on them.
        // Was:
        // case GET_AI_COPILOT_QUESTIONS_SUCCESS: {
        //     const existingQuestions = Array.isArray(state.aiCopilotQuestions) ? state.aiCopilotQuestions : [];
        //     const seenQuestions = new Set(existingQuestions.map((q) => normalizeCopilotQuestion(q?.question)));
        //     const newQuestions = [];
        //     (Array.isArray(action.payload?.next_questions) ? action.payload.next_questions : []).forEach((q) => {
        //         const key = normalizeCopilotQuestion(q?.question);
        //         if (!key || seenQuestions.has(key)) return;
        //         seenQuestions.add(key);
        //         newQuestions.push(q);
        //     });
        //     return {
        //         ...state,
        //         aiCopilotQuestionsLoading: false,
        //         aiCopilotQuestions: [...newQuestions.slice(0, AI_COPILOT_MAX_PER_BATCH), ...existingQuestions].slice(
        //             0,
        //             AI_COPILOT_MAX_VISIBLE
        //         ),
        //         aiCopilotSkillCoverage: action.payload?.skill_coverage || state.aiCopilotSkillCoverage,
        //         candidateAiAnalysis: action.payload?.candidate_ai_analysis || state.candidateAiAnalysis,
        //     };
        // }
        case GET_AI_COPILOT_QUESTIONS_SUCCESS: {
            const requestSeq = Number(action.payload?.request_seq);
            const hasSeq = Number.isFinite(requestSeq) && requestSeq > 0;
            if (hasSeq && requestSeq < state.aiCopilotLastSeq) {
                return { ...state, aiCopilotQuestionsLoading: false };
            }
            const answerKey = typeof action.payload?.answer?.key === 'string' ? action.payload.answer.key : '';
            const existingQuestions = Array.isArray(state.aiCopilotQuestions) ? state.aiCopilotQuestions : [];
            // Questions of other answers; this answer's earlier batch makes room only if new ones arrive.
            const otherQuestions = answerKey
                ? existingQuestions.filter((q) => q?.answer_key !== answerKey)
                : existingQuestions;
            const seenQuestions = new Set(otherQuestions.map((q) => normalizeCopilotQuestion(q?.question)));
            const newQuestions = [];
            (Array.isArray(action.payload?.next_questions) ? action.payload.next_questions : []).forEach((q) => {
                const key = normalizeCopilotQuestion(q?.question);
                if (!key || seenQuestions.has(key)) return;
                seenQuestions.add(key);
                newQuestions.push(answerKey ? { ...q, answer_key: answerKey } : q);
            });
            const keptQuestions = newQuestions.length ? otherQuestions : existingQuestions;
            return {
                ...state,
                aiCopilotQuestionsLoading: false,
                // Only a reply that brought questions counts as "the newest applied". A skipped request answers
                // in ~0.1 s with no questions and would otherwise make a slower, valid reply look out of date.
                aiCopilotLastSeq: hasSeq && newQuestions.length ? requestSeq : state.aiCopilotLastSeq,
                // [2026-10-15] CHANGED — INC-279 C1 (CONTRACTS Round 1): no cap on the list any more (the mock keeps
                // every card until it is cleared); still at most 2 per batch. Was:
                // aiCopilotQuestions: [...newQuestions.slice(0, AI_COPILOT_MAX_PER_BATCH), ...keptQuestions].slice(
                //     0,
                //     AI_COPILOT_MAX_VISIBLE
                // ),
                aiCopilotQuestions: [...newQuestions.slice(0, AI_COPILOT_MAX_PER_BATCH), ...keptQuestions],
                aiCopilotSkillCoverage: action.payload?.skill_coverage || state.aiCopilotSkillCoverage,
                candidateAiAnalysis: action.payload?.candidate_ai_analysis || state.candidateAiAnalysis,
            };
        }
        case GET_AI_COPILOT_QUESTIONS_FAILURE:
            return { ...state, aiCopilotQuestionsLoading: false };
        case GET_COPILOT_BOOKMARKS:
            return { ...state, copilotBookmarksLoading: true };
        case GET_COPILOT_BOOKMARKS_SUCCESS:
            return { ...state, copilotBookmarksLoading: false, copilotBookmarks: action.payload };
        case GET_COPILOT_BOOKMARKS_FAILURE:
            return { ...state, copilotBookmarksLoading: false };
        case ADD_COPILOT_BOOKMARK:
            return { ...state, addCopilotBookmarkLoading: true };
        case ADD_COPILOT_BOOKMARK_SUCCESS:
            return {
                ...state,
                addCopilotBookmarkLoading: false,
                copilotBookmarks: [...state.copilotBookmarks, action.payload],
            };
        case ADD_COPILOT_BOOKMARK_FAILURE:
            return { ...state, addCopilotBookmarkLoading: false };
        case DELETE_COPILOT_BOOKMARK:
            return { ...state, deleteCopilotBookmarkLoading: true };
        case DELETE_COPILOT_BOOKMARK_SUCCESS:
            return {
                ...state,
                deleteCopilotBookmarkLoading: false,
                copilotBookmarks: state.copilotBookmarks.filter((b) => b.question !== action.payload),
            };
        case DELETE_COPILOT_BOOKMARK_FAILURE:
            return { ...state, deleteCopilotBookmarkLoading: false };
        // [2026-10-07] ADDED — INC-279: IncAssist "Live transcript" tab (list logic in transcriptModel.js)
        case GET_COPILOT_TRANSCRIPT_SUCCESS:
            return { ...state, copilotTranscript: applyHistory(state.copilotTranscript, action.payload) };
        case COPILOT_TRANSCRIPT_SNAPSHOT: {
            const { lines, gap } = applySnapshot(state.copilotTranscript, action.payload);
            return {
                ...state,
                copilotTranscript: lines,
                copilotTranscriptPushes: state.copilotTranscriptPushes + 1,
                copilotTranscriptGap: gap ? state.copilotTranscriptGap + 1 : state.copilotTranscriptGap,
            };
        }
        // [2026-10-07] ADDED — INC-279: the AI-assisted check of one finished answer. Only a positive result is
        // kept. `answer` says which transcript lines were checked; without times (the backend used the
        // browser's own words) the newest candidate bubble is marked.
        case CHECK_COPILOT_ANSWER_SUCCESS: {
            const result = action.payload || {};
            if (result.status !== 'checked' || !result.isAIText) return state;
            let source = result.answer?.source === 'live' ? 'live' : 'db';
            let from = Date.parse(result.answer?.from);
            let to = Date.parse(result.answer?.to);
            if (!Number.isFinite(from) || !Number.isFinite(to)) {
                const span = latestCandidateSpan(state.copilotTranscript, null);
                if (span) ({ source, from, to } = span);
            }
            const key = result.answer?.key || `flag:${from}`;
            if (state.copilotAiFlags.some((flag) => flag.key === key)) return state;
            const score = Number(result.score);
            return {
                ...state,
                copilotAiFlags: [
                    ...state.copilotAiFlags,
                    { key, source, from, to, score: Number.isFinite(score) ? score : null, seen: false },
                ].slice(-COPILOT_AI_FLAGS_MAX),
            };
        }
        case COPILOT_AI_FLAGS_SEEN:
            if (!state.copilotAiFlags.some((flag) => !flag.seen)) return state;
            return { ...state, copilotAiFlags: state.copilotAiFlags.map((flag) => ({ ...flag, seen: true })) };
        // [2026-10-15] ADDED — INC-279 F: the panel's state. An unchanged reply returns the same state, so the
        // 15-second poll re-renders nothing when nothing changed.
        case GET_COPILOT_STATE_SUCCESS: {
            const result = action.payload || {};
            if (result.status !== 'ok') return state;
            const next = {
                copilotSkillCounts: Array.isArray(result.skills) ? result.skills : state.copilotSkillCounts,
                copilotQuestionsCounted: Number.isFinite(result.questions_counted)
                    ? result.questions_counted
                    : state.copilotQuestionsCounted,
            };
            // [2026-10-15] ADDED — INC-279 IncAssist C1/C2: the starters plan (CONTRACTS C2 getCopilotState.plan).
            if (result.plan && typeof result.plan === 'object' && result.plan.status) next.copilotPlan = result.plan;
            // [2026-10-17] ADDED — INC-279 IncAssist RS: the Project Deep-Dive scan (status, repo_name, questions).
            if (result.repo_scan && typeof result.repo_scan === 'object' && result.repo_scan.status)
                next.copilotRepoScan = result.repo_scan;
            if (result.proctoring && typeof result.proctoring === 'object') {
                next.copilotProctoringEntries = Array.isArray(result.proctoring.entries)
                    ? result.proctoring.entries
                    : state.copilotProctoringEntries;
                next.copilotProctoringCounts = result.proctoring.counts || state.copilotProctoringCounts;
                next.copilotProctoringLatestAt = result.proctoring.latest_at ?? state.copilotProctoringLatestAt;
            }
            // [2026-10-15] ADDED — INC-279 IncAssist P3: the interview's start, for the log's "mm:ss into the interview".
            if (result.interview_started_at) next.copilotProctoringStartedAt = result.interview_started_at;
            const changed = Object.keys(next).some((k) => JSON.stringify(next[k]) !== JSON.stringify(state[k]));
            return changed ? { ...state, ...next } : state;
        }
        // [2026-10-15] ADDED — INC-279 IncAssist P3: the Proctoring tab was seen: nothing is "new" any more until the
        // next flagged event (the next getCopilotState sends proctoring_since = this time).
        // [2026-10-29] CHANGED — INC-2050: also records the ids of the flagged entries on screen (copilotProctoringSeenIds),
        // which the badge now counts against. Was:
        // case COPILOT_PROCTORING_SEEN: {
        //     const at = action.payload?.at || new Date().toISOString();
        //     if (state.copilotProctoringSeenAt === at && !state.copilotProctoringCounts?.new_since) return state;
        //     return {
        //         ...state,
        //         copilotProctoringSeenAt: at,
        //         copilotProctoringCounts: { ...state.copilotProctoringCounts, new_since: 0 },
        //     };
        // }
        case COPILOT_PROCTORING_SEEN: {
            const at = action.payload?.at || new Date().toISOString();
            const seenIds = addSeenIds(state.copilotProctoringSeenIds, state.copilotProctoringEntries);
            if (
                state.copilotProctoringSeenAt === at &&
                !state.copilotProctoringCounts?.new_since &&
                seenIds === state.copilotProctoringSeenIds
            )
                return state;
            return {
                ...state,
                copilotProctoringSeenAt: at,
                copilotProctoringSeenIds: seenIds,
                copilotProctoringCounts: { ...state.copilotProctoringCounts, new_since: 0 },
            };
        }
        // [2026-10-29] ADDED — INC-2049: the list saved in this browser before a refresh/rejoin, merged into what is
        // already here (never wipes; aiCopilotLastSeq is not touched).
        case COPILOT_SESSION_RESTORE: {
            const merged = mergeSession(state, action.payload);
            return Object.keys(merged).length ? { ...state, ...merged } : state;
        }
        case COPILOT_PROCTORING_FOCUS:
            return {
                ...state,
                copilotProctoringFocus: action.payload?.id
                    ? { id: String(action.payload.id), key: (state.copilotProctoringFocus?.key || 0) + 1 }
                    : null,
            };
        // [2026-10-15] ADDED — INC-279 IncAssist C1/C2: see components/AICopilot/copilotListModel.js.
        case COPILOT_UI_PATCH:
            return { ...state, copilotUi: { ...state.copilotUi, ...(action.payload || {}) } };
        case COPILOT_UI_REGISTER: {
            const copilotUi = registerIds(state.copilotUi, action.payload?.ids, { read: !!action.payload?.read });
            return copilotUi === state.copilotUi ? state : { ...state, copilotUi };
        }
        case COPILOT_UI_READ: {
            const copilotUi = markRead(state.copilotUi, action.payload?.id);
            return copilotUi === state.copilotUi ? state : { ...state, copilotUi };
        }
        case COPILOT_UI_CLEAR:
            return { ...state, copilotUi: clearIds(state.copilotUi, action.payload?.ids, action.payload?.message) };
        case COPILOT_UI_UNDO:
            return { ...state, copilotUi: undoClear(state.copilotUi) };
        case GET_COPILOT_STARTERS_SUCCESS: {
            const result = action.payload || {};
            if (!result.status || result.status === 'unavailable') return state;
            return {
                ...state,
                copilotPlan: {
                    ...state.copilotPlan,
                    status: result.status,
                    reason: result.reason,
                    starters: Array.isArray(result.starters) ? result.starters : state.copilotPlan.starters,
                },
            };
        }
        case GET_COPILOT_SKILL_QUESTION_SUCCESS: {
            // A new card on top: it slides in, flashes, and a toast names the skill (mock app.js:455-465).
            const list = addSkillQuestion(state.copilotSkillQuestions, action.payload?.question);
            if (list === state.copilotSkillQuestions) return state;
            const id = list[0].id;
            return {
                ...state,
                copilotSkillQuestions: list,
                copilotUi: {
                    ...registerIds(state.copilotUi, [id]),
                    enteringId: id,
                    flash: { id, key: (state.copilotUi.flash?.key || 0) + 1 },
                    toast: nextToast(action.payload?.message || ''),
                },
            };
        }
        case GET_COPILOT_SKILL_QUESTION_FAILURE:
            return action.payload?.message
                ? { ...state, copilotUi: { ...state.copilotUi, toast: nextToast(action.payload.message) } }
                : state;
        // [2026-10-16] ADDED — INC-279 IncAssist C5: 2 "Coding" cards on top of the one list. The panel registers them
        // as unread (pill badge) like any new card; no toast, no flash.
        case GET_COPILOT_CODE_FOLLOW_UPS_SUCCESS: {
            const list = addCodeQuestions(
                state.copilotCodeQuestions,
                action.payload?.questions,
                action.payload?.prompt_version
            );
            return list === state.copilotCodeQuestions ? state : { ...state, copilotCodeQuestions: list };
        }
        default:
            return state;
    }
};
export default Interview;
